import { z } from 'zod';
export const MeetingsMetadataSchema = z
    .object({
    ['Content-Type']: z.string().optional(),
    dateCreated: z.string().datetime().optional(),
    description: z.string().optional(),
    geoAccuracy: z.number().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    phoneModel: z.string().optional(),
    photoTime: z.string().datetime().optional(),
    videoTime: z.number().optional(),
    label: z.string().optional(),
})
    .and(z.record(z.string(), z.any()));
